import {
  formatMatchKickoffLabel,
  formatOddValue,
  matchBannerBackground,
  sportEventFromMatch,
} from './featuredMatchSlides';

/**
 * GR8 medium-banner sport item: time, Home × Away, league, 1X2 frosted odds.
 * Background must be player-action compose (no stadium-only plates).
 */
export default function FeaturedMatchSlide({
  match: ev,
  locale = 'tr',
  onOpen,
  onOddOpen,
}) {
  if (!ev) return null;
  const live = Boolean(ev.is_live);
  const isDemo = Boolean(ev.gr8_demo);
  const bg = matchBannerBackground(ev);
  const timeLabel = live
    ? (locale === 'en' ? 'LIVE' : 'CANLI')
    : formatMatchKickoffLabel(ev.start_time, locale);
  const title = `${ev.home_team || ''} × ${ev.away_team || ''}`.trim();
  const league = ev.league || ev.sport_name || '';
  const odds = Array.isArray(ev.odds) ? ev.odds.slice(0, 3) : [];
  const openEvent = () => onOpen?.(sportEventFromMatch(ev));

  return (
    <div
      role="link"
      tabIndex={0}
      className={`welcome-match${live ? ' is-live' : ''}${isDemo ? ' is-demo' : ''}`}
      onClick={openEvent}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openEvent();
        }
      }}
      aria-label={title}
    >
      <img
        className="welcome-match__bg"
        src={bg}
        alt=""
        aria-hidden="true"
        draggable={false}
        onError={(e) => {
          if (e.currentTarget.dataset.fallback === '1') return;
          e.currentTarget.dataset.fallback = '1';
          e.currentTarget.src = '/top-events/football.jpg';
        }}
      />
      <span className="welcome-match__wash" aria-hidden="true" />
      <div className="welcome-match__body">
        <div className="welcome-match__meta">
          <span className={`welcome-match__time${live ? ' is-live' : ''}`} data-testid="time-status">
            {timeLabel}
          </span>
          <h2 className="welcome-match__title" data-testid="title-text" title={title}>{title}</h2>
          {league ? (
            <h3 className="welcome-match__league" data-testid="subtitle-text">{league}</h3>
          ) : null}
        </div>
        {odds.length ? (
          <div className="welcome-match__odds" data-testid="outcomes-section">
            {odds.map((odd, idx) => {
              // Demo stubs have display odds only — open sportsbook, don't coupon.
              const blocked = Boolean(odd.blocked) || odd.value == null;
              const tick = odd.tick === 'up' || odd.tick === 'down' ? odd.tick : null;
              const edge =
                idx === 0 ? ' is-first' : idx === odds.length - 1 ? ' is-last' : ' is-mid';
              return (
                <button
                  key={`${odd.label}-${odd.id || odd.point || odd.value}-${tick || 'x'}`}
                  type="button"
                  data-testid="outcome"
                  className={`welcome-match__odd${edge}${blocked ? ' is-blocked' : ''}${tick ? ` is-${tick}` : ''}`}
                  disabled={blocked}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (blocked) return;
                    if (isDemo) {
                      openEvent();
                      return;
                    }
                    onOddOpen?.(sportEventFromMatch(ev, odd));
                  }}
                >
                  <span className={`welcome-match__odd-value${tick ? ` is-${tick}` : ''}`} data-testid="odd">
                    {blocked ? '—' : formatOddValue(odd.value)}
                  </span>
                  <span className="welcome-match__odd-label" data-testid="outcome-name">
                    {odd.label}
                  </span>
                </button>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
}
